module.exports = __webpack_public_path__ + "media/images/athletes/485-a8210da17092490916b27cc326fcc58e.png";